// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Pagination,
//   TextField,
//   Card,
//   CardContent,
//   CardHeader,
//   IconButton,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';

// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const Interested = () => {
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [data, setData] = useState([]);

//   const investor_id = localStorage.getItem('user_id');

//   useEffect(() => {
//     fetchInterestedProjects();
//   }, []);

//   const fetchInterestedProjects = async () => {
//     try {
//       const endpoint = `https://puneexpobackend.tdtlworld.com/api/self_investor/${investor_id}/`;
//       const response = await axios.get(endpoint);
//       const fetchedData = response.data.interested.map((item) => ({
//         id: item.id,
//         title: item.idea.title,
//         description: item.idea.description,
//         projectType: item.idea.project_type || 'N/A',
//         submissionDate: item.idea.created_at,
//         aiScore: item.idea.ai_score || 'N/A',
//         isSingleSubmission: item.idea.is_single_sub ? 'Yes' : 'No',
//         groupName: item.idea.name_of_group || 'N/A',
//         members: item.idea.number_of_member || 'N/A',
//         ideaFile: item.idea.idea || 'No file',
//         pptFile: item.idea.ppt || 'No file',
//         videoFile: item.idea.video_file || 'No file',
//       }));

//       setData(fetchedData);
//     } catch (error) {
//       console.error('Error fetching interested projects:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     (row.title || '').toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#000', mt: 8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>Interested Projects</Typography>}
//           subheader="View projects you have shown interest in"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', mt: 8 }}>
//         <CardContent>
//           <TextField
//             placeholder="Search by Project Title"
//             size="small"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//             InputProps={{
//               startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//             }}
//             sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//           />
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project PDF</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>PPT</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>AI Score</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Video</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#FCE4EC' } }}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.ideaFile !== 'No file' ? (
//                       <IconButton
//                         size="small"
//                         href={row.ideaFile}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     {row.pptFile !== 'No file' ? (
//                       <IconButton
//                         size="small"
//                         href={row.pptFile}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>{row.aiScore}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.videoFile !== 'No file' ? (
//                       <IconButton
//                         size="small"
//                         href={row.videoFile}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>
//     </Box>
//   );
// };

// export default Interested;
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  TextField,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
 
const StyledTableCell = styled(TableCell)({
  padding: '16px',
  fontSize: '0.875rem',
  color: '#4A4A4A',
});
 
const ITEMS_PER_PAGE = 5;
 
const Interested = () => {
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('All');
  const [filterScore, setFilterScore] = useState('All');
  const [filterCategory, setFilterCategory] = useState('All');
  const [data, setData] = useState([]);
 
  const investor_id = localStorage.getItem('user_id');
 
  useEffect(() => {
    fetchInterestedProjects();
  }, []);
 
  const fetchInterestedProjects = async () => {
    try {
      const endpoint = `https://puneexpobackend.tdtlworld.com/api/self_investor/${investor_id}/`;
      const response = await axios.get(endpoint);
      const fetchedData = response.data.interested.map((item) => ({
        id: item.id,
        title: item.idea.title,
        description: item.idea.description,
        projectType: item.idea.project_type || 'N/A',
        submissionDate: item.idea.created_at,
        aiScore: item.idea.ai_score || 'N/A',
        isSingleSubmission: item.idea.is_single_sub ? 'Yes' : 'No',
        groupName: item.idea.name_of_group || 'N/A',
        members: item.idea.number_of_member || 'N/A',
        ideaFile: item.idea.idea || 'No file',
        pptFile: item.idea.ppt || 'No file',
        videoFile: item.idea.video_file || 'No file',
      }));
 
      setData(fetchedData);
    } catch (error) {
      console.error('Error fetching interested projects:', error);
    }
  };
 
  const handleChangePage = (event, newPage) => setPage(newPage);
 
  const handleFilterChange = (filterName, value) => {
    if (filterName === 'type') {
      setFilterType(value);
    } else if (filterName === 'score') {
      setFilterScore(value);
    } else if (filterName === 'category') {
      setFilterCategory(value);
    }
  };
 
  const filteredData = data.filter((row) => {
    const matchesSearch = (row.title || '').toLowerCase().includes(searchTerm);
    const matchesType = filterType === 'All' || row.projectType === filterType;
    const matchesScore =
      filterScore === 'All' || (filterScore === 'High' ? row.aiScore > 75 : row.aiScore <= 75);
    const matchesCategory = filterCategory === 'All' || row.projectType === filterCategory;
    return matchesSearch && matchesType && matchesScore && matchesCategory;
  });
 
  const paginatedData = filteredData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );
 
  return (
    <Box sx={{ p: 4, background: 'linear-gradient(135deg, #E8F5E9, #E3F2FD)', minHeight: '100vh' }}>
      <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#FAFAFA', color: '#000', mt: 8 }}>
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2C3E50' }}>Interested Projects</Typography>}
          subheader="View projects you have shown interest in"
          sx={{ py: 2, borderBottom: '1px solid #E0E0E0' }}
        />
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              placeholder="Search by Project Title"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: '#2C3E50' }} />,
              }}
              sx={{ width: '300px', backgroundColor: '#F8F9FA', borderRadius: 2 }}
            />
 
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Project Type</InputLabel>
              <Select
                value={filterType}
                onChange={(e) => handleFilterChange('type', e.target.value)}
                label="Project Type"
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Single">Single</MenuItem>
                <MenuItem value="Group">Group</MenuItem>
              </Select>
            </FormControl>
 
            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>AI Score</InputLabel>
              <Select
                value={filterScore}
                onChange={(e) => handleFilterChange('score', e.target.value)}
                label="AI Score"
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="High">High (&gt;75)</MenuItem>
                <MenuItem value="Low">Low (&le;75)</MenuItem>
              </Select>
            </FormControl>
 
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={filterCategory}
                onChange={(e) => handleFilterChange('category', e.target.value)}
                label="Category"
              >
                <MenuItem value="All">All Categories</MenuItem>
                <MenuItem value="AI/ML">AI/ML</MenuItem>
                <MenuItem value="Technology">Technology</MenuItem>
                <MenuItem value="Real Estate">Real Estate</MenuItem>
                <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
                <MenuItem value="Pharmacy ">Pharmacy</MenuItem>
                <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
                <MenuItem value="Education">Education</MenuItem>
                <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
                <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
                <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
                <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
                <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </CardContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#B0BEC5' }}>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Project Title</StyledTableCell>
                <StyledTableCell>Project Type</StyledTableCell>
                <StyledTableCell>Project PDF</StyledTableCell>
                <StyledTableCell>PPT</StyledTableCell>
                <StyledTableCell>AI Score</StyledTableCell>
                <StyledTableCell>Project Video</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{ '&:hover': { backgroundColor: '#ECEFF1' } }}
                >
                  <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
                  <StyledTableCell>{row.title}</StyledTableCell>
                  <StyledTableCell>{row.projectType}</StyledTableCell>
                  <StyledTableCell>
                    {row.ideaFile !== 'No file' ? (
                      <IconButton
                        size="small"
                        href={row.ideaFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.pptFile !== 'No file' ? (
                      <IconButton
                        size="small"
                        href={row.pptFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                  <StyledTableCell>{row.aiScore}</StyledTableCell>
                  <StyledTableCell>
                    {row.videoFile !== 'No file' ? (
                      <IconButton
                        size="small"
                        href={row.videoFile}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
 
        <Pagination
          count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handleChangePage}
          sx={{ mt: 3 }}
        />
      </Card>
    </Box>
  );
};
 
export default Interested;